import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { api } from '../utils/api';
import OperationsHero from '../components/OperationsHero';

const money = (value) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value || 0);

export default function Dashboard() {
  const { token } = useAuth();
  const [stats, setStats] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get('/dashboard/stats', token)
      .then(setStats)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [token]);

  const cards = stats
    ? [
        ['New Orders', stats.new_orders, 'text-brand-600'],
        ['Processing', stats.processing, 'text-sky-700'],
        ['Today Revenue', money(stats.today_revenue), 'text-emerald-700'],
        ['Month Revenue', money(stats.month_revenue), 'text-emerald-700'],
        ['Total Orders', stats.total_orders, 'text-slate-900'],
        ['Low Stock', stats.low_stock, 'text-orange-600'],
        ['Sold Out', stats.sold_out, 'text-red-600']
      ]
    : [];

  return (
    <div className="space-y-6">
      <OperationsHero />
      {error ? <div className="status-banner-error">{error}</div> : null}

      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
        {cards.map(([label, value, valueClass]) => (
          <div key={label} className="stat-card">
            <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
              {label}
            </p>
            <p className={`mt-3 text-3xl font-bold ${valueClass}`}>{value}</p>
          </div>
        ))}
      </div>

      {loading ? (
        <div className="card p-6 loading-pulse">Loading dashboard stats...</div>
      ) : null}
    </div>
  );
}
